import { render, staticRenderFns } from "./OfferPermissionsForm.vue?vue&type=template&id=0bedc38a&scoped=true"
import script from "./OfferPermissionsForm.vue?vue&type=script&lang=js"
export * from "./OfferPermissionsForm.vue?vue&type=script&lang=js"
import style0 from "./OfferPermissionsForm.vue?vue&type=style&index=0&id=0bedc38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bedc38a",
  null
  
)

export default component.exports